export default __webpack_public_path__ + "static/media/justeat.5d879c83.webp";